import React from 'react';

const SettingsSection = ({ title, icon: Icon, iconColor = 'text-muted', children, className = '', allowOverflow = false }) => {
  return (
    <div className={`bg-dark-card border border-dark-border rounded-xl p-6 ${allowOverflow ? '' : ''} ${className}`}>
      <h2 className="text-lg font-semibold text-primary mb-4 flex items-center">
        {Icon && <Icon className={`h-5 w-5 mr-2 ${iconColor}`} />}
        {title}
      </h2>
      {children}
    </div>
  );
};

export default SettingsSection;
